/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import { FC, ReactElement } from 'react';
import Input from '~/view/components/Controls/InputComponent/Input';
import { IInputProps } from '~/view/components/Controls/InputComponent/types';
import Text from '~/view/components/Text/Text';
import { ITextProps } from '~/view/components/Text/types';
import './style.scss';

type TTextProps = Omit<ITextProps, 'type'>;
interface IProps extends IInputProps {
  textProps: TTextProps;
}
const InputWithTextInsideAfter: FC<IProps> = ({ textProps, inputClassName, ...props }: IProps): ReactElement => {
  return (
    <Input
      {...props}
      inputClassName={classNames('input-with-text-inside-after', inputClassName)}
      nextComponent={<Text {...textProps} type="title-inside-input" />}
    />
  );
};

export default InputWithTextInsideAfter;
